// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__byDsP","section-1":"styles_section-1__S+mY2","content":"styles_content__qVd0n","section-2":"styles_section-2__Kqlqh"};